import React from 'react'
import styled from '@emotion/styled'
import { colors, font, radius, shadow, spacing } from '@mobi/component-library/Foundations'

export const Container = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode; topComponent?: React.ReactNode }
>(({ children, topComponent }, ref) => {
  return (
    <CardStyled ref={ref} data-testid='BetCard'>
      <div>{topComponent}</div>

      <div>{children}</div>
    </CardStyled>
  )
})

Container.displayName = 'Container'

// ======
// Styles
// ======

const CardStyled = styled.div({
  overflow: 'hidden',
  border: '1px solid ' + colors.neutral[300],
  borderRadius: radius.lgx3,
  boxShadow: shadow.xs,
  fontFamily: font.family.primary,

  '> div:first-of-type': {
    overflow: 'hidden',
    borderTopLeftRadius: radius.lgx3,
    borderTopRightRadius: radius.lgx3,

    ':empty': { display: 'none' },
  },

  '> div:last-of-type': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
    padding: spacing.sm,
    backgroundColor: colors.white,
    borderBottomLeftRadius: radius.lgx3,
    borderBottomRightRadius: radius.lgx3,
  },
})
